import { render } from "./appPaperCenter.vue?vue&type=template&id=353eff72&scoped=true"
import script from "./appPaperCenter.vue?vue&type=script&lang=js"
export * from "./appPaperCenter.vue?vue&type=script&lang=js"

import "./appPaperCenter.vue?vue&type=style&index=0&id=353eff72&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353eff72"]])

export default __exports__